<ng-content />
<div
  class="d-flex fd-col jc-start ai-stretch"
  [class]="{ 'scrolling-smart-grid-container': scrollEnabled && !editMode }"
>
  <div *ngIf="editMode && !editingActive" class="edit-toolbar">
    <div class="title-container">
      <div class="title-stack">
        <div class="title-label">{{ displayNameLabel ? displayNameLabel : 'Display Name' }}</div>
        <h4 style="word-wrap: normal; white-space: nowrap">
          {{ gridForm.controls['displayName'].value }}
        </h4>
      </div>
    </div>

    <div class="edit-buttons-container d-flex fd-row flex-wrap">
      <button mat-flat-button color="primary" (click)="startEditing()">Edit</button>
    </div>
  </div>
  <!-- Edit Toolbar -->
  <div *ngIf="editMode && editingActive" class="edit-toolbar">
    <div class="edit-inputs-container" [formGroup]="gridForm">
      <mat-form-field appearance="outline">
        <mat-label>{{ displayNameLabel ? displayNameLabel : 'Display Name' }}</mat-label>
        <input matInput formControlName="displayName" />
        <mat-error *ngIf="displayNameControl.errors?.required && displayNameControl.touched">
          Display Name is required
        </mat-error>
      </mat-form-field>
      <br />
      <!-- <mat-form-field appearance="outline">
        <mat-label>Short Code</mat-label>
        <input matInput formControlName="shortCode" />
        <mat-error *ngIf="shortCodeControl.errors?.required && shortCodeControl.touched">
          Short Code is required
        </mat-error>
      </mat-form-field> -->
    </div>

    <div class="edit-buttons-container d-flex fd-row flex-wrap">
      <button
        mat-button
        color="primary"
        class="cancel-button"
        (click)="stopEditing()"
        *ngIf="editMode && editingActive && !changesUnsaved"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        color="warn"
        *ngIf="editMode && editingActive && changesUnsaved"
        (click)="discardChanges()"
      >
        <mat-icon>undo</mat-icon>
        Revert
      </button>
      <ng-container *ngIf="saveMode != 'draftsAndPublish'">
        <button
          mat-flat-button
          color="primary"
          [disabled]="(!isCreation && !changesUnsaved) || gridForm.invalid"
          (click)="saveChanges(false)"
        >
          <mat-icon>save</mat-icon>
          {{ isCreation ? 'Create' : 'Save' }}
        </button>
      </ng-container>
      <ng-container *ngIf="saveMode == 'draftsAndPublish'">
        <button
          mat-flat-button
          color="primary"
          [disabled]="(!isCreation && !changesUnsaved) || gridForm.invalid"
          (click)="saveChanges(false)"
        >
          {{ isCreation ? 'Create' : 'Save draft' }}
        </button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="publishButtonDisabled"
          (click)="saveChanges(true)"
        >
          <mat-icon>publish</mat-icon>
          {{ publishButtonLabel }}
        </button>
      </ng-container>
    </div>
  </div>

  <!-- SECTIONS CONTAINER -->

  <div
    cdkDropList
    [cdkDropListDisabled]="!editMode"
    [cdkDropListData]="grid.sections"
    (cdkDropListDropped)="sectionDropped($event)"
    *ngIf="grid?.sections; else errorSection"
    class="d-flex fd-col ai-stretch"
  >
    <!-- SECTION -->

    <div cdkDrag *ngFor="let section of grid.sections; let sectionIndex = index">
      <!-- ROWS CONTAINER -->
      <div
        id="Section{{ sectionIndex }}"
        [cdkDropListConnectedTo]="sectionConnectedListIds"
        cdkDropList
        [cdkDropListDisabled]="!editMode"
        cdkDropListOrientation="vertical"
        [cdkDropListData]="section.rows"
        (cdkDropListDropped)="rowDropped($event)"
        class="d-flex fd-col ai-stretch gap-12"
      >
        <!-- ROW -->
        <div
          cdkDrag
          *ngFor="let row of section.rows; let rowIndex = index"
          class="row-container full-width d-flex fd-col ai-stretch"
          [class.row-container-edit-mode]="editMode && editingActive"
        >
          <!-- ROW EDIT HEADER -->
          <div
            *ngIf="editMode && editingActive"
            class="edit-row-toolbar d-flex fd-row jc-between ai-center"
          >
            <!-- DRAG ROW -->
            <div class="d-flex fd-row ai-center row-toolbar-left">
              <button cdkDragHandle mat-icon-button matTooltip="Drag row">
                <mat-icon>drag_handle</mat-icon>
              </button>
              <span class="row-label">Row</span>
              <span class="row-toolbar-separator" aria-hidden="true"></span>

              <div class="row-column-count-toggle" role="group" aria-label="Row column count">
                @for (columnCount of getRowColumnCountOptions(); track columnCount) {
                  <button
                    type="button"
                    mat-icon-button
                    class="row-column-count-button"
                    [class.active]="row.columns.length === columnCount"
                    [attr.aria-pressed]="row.columns.length === columnCount"
                    [matTooltip]="columnCount + ' column' + (columnCount === 1 ? '' : 's')"
                    (click)="setRowColumnCount(sectionIndex, rowIndex, columnCount)"
                  >
                    <svg
                      class="row-column-count-icon"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      focusable="false"
                    >
                      @switch (columnCount) {
                        @case (1) {
                          <rect x="3" y="3" width="18" height="18" rx="2" />
                        }
                        @case (2) {
                          <rect x="3" y="3" width="7.5" height="18" rx="1.5" />
                          <rect x="13.5" y="3" width="7.5" height="18" rx="1.5" />
                        }
                        @case (3) {
                          <rect x="3" y="3" width="4" height="18" rx="1.25" />
                          <rect x="10" y="3" width="4" height="18" rx="1.25" />
                          <rect x="17" y="3" width="4" height="18" rx="1.25" />
                        }
                      }
                    </svg>
                  </button>
                }
              </div>
            </div>

            <div></div>

            <!-- REMOVE ROW -->
            <div class="d-flex fd-row jc-end ai-center">
              <button
                mat-icon-button
                class="row-edit-action"
                (click)="removeRow(sectionIndex, rowIndex)"
                matTooltip="Delete row"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <!-- ROW TILES -->
          <div
            id="Row{{ rowIndex }}"
            cdkDropList
            [cdkDropListDisabled]="!editMode"
            [cdkDropListConnectedTo]="rowConnectedListIds"
            [cdkDropListOrientation]="rowDropListOrientation"
            [cdkDropListData]="row.columns"
            (cdkDropListDropped)="tileDropped($event)"
            [cdkDropListEnterPredicate]="tileEnterPredicate"
            class="row-tiles-container d-flex flex-wrap ai-stretch fd-col--lt-md gap-12"
          >
            <ng-container *ngFor="let column of row.columns; let columnIndex = index">
              <!-- TILE -->
              <div
                cdkDrag
                #tileContainer
                class="slim-padding edit-hover-background tile-edit flex-1 d-flex fd-col ai-stretch"
                [class.tile-edit-enabled]="editMode && editingActive"
                [class.hidden-tile]="!editMode && !!column.tileDefinition?.meta?.hidden"
                [class.no-padding]="!column.tileDefinition?.displayProperties?.padding"
                style="flex: 1 1 0px"
              >
                <!-- TILE EDIT HEADER -->
                <div
                  *ngIf="editMode && editingActive"
                  class="edit-tile-toolbar d-flex fd-row jc-between ai-center"
                  [class.edit-tile-toolbar-card]="!column.tileDefinition?.displayProperties?.noCard"
                  [class.edit-tile-toolbar-no-card]="!!column.tileDefinition?.displayProperties?.noCard"
                  [style.color]="getTileToolbarForegroundColor(tileContainer)"
                >
                  <div class="d-flex fd-row ai-center">
                    <button
                      cdkDragHandle
                      mat-icon-button
                      class="edit-hidden-button"
                      matTooltip="Drag tile"
                    >
                      <mat-icon>drag_handle</mat-icon>
                    </button>
                    <p class="edit-label">
                      {{ (column.tileDefinition?.tileType | titlecase) || 'Tile' }}
                    </p>
                  </div>

                  <div class="d-flex fd-row jc-end ai-center">
                    <button
                      matTooltip="{{
                        row.columns.length >= (settings?.maxColumnCount || 3)
                          ? 'Maximum of 3 columns'
                          : 'Add column to the right'
                      }}"
                      mat-icon-button
                      class="edit-hidden-button"
                      [disabled]="row.columns.length >= (settings?.maxColumnCount || 3)"
                      (click)="addColumnToRow(sectionIndex, rowIndex, columnIndex + 1)"
                    >
                      <mat-icon>add</mat-icon>
                    </button>

                    <button
                      matTooltip="Render within card"
                      mat-icon-button
                      class="edit-hidden-button card-btn"
                      (click)="
                        toggleColumnDisplayProperty('noCard', sectionIndex, rowIndex, columnIndex)
                      "
                      [class.active]="!column.tileDefinition?.displayProperties?.noCard"
                    >
                      <mat-icon>check_box_outline_blank</mat-icon>
                    </button>

                    <button
                      matTooltip="Add padding"
                      mat-icon-button
                      class="edit-hidden-button padding-btn"
                      (click)="
                        toggleColumnDisplayProperty('padding', sectionIndex, rowIndex, columnIndex)
                      "
                      [class.active]="!!column.tileDefinition?.displayProperties?.padding"
                    >
                      <mat-icon>padding</mat-icon>
                    </button>

                    <span
                      [matTooltip]="
                        canEditTile(column.tileDefinition)
                          ? 'Edit tile'
                          : 'Pick a tile type before editing'
                      "
                      [matTooltipDisabled]="canEditTile(column.tileDefinition)"
                    >
                      <button
                        mat-icon-button
                        class="edit-hidden-button"
                        [disabled]="!canEditTile(column.tileDefinition)"
                        (click)="openColumnEditDialog(sectionIndex, rowIndex, columnIndex)"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                    </span>

                    <button
                      matTooltip="Edit tile JSON (Advanced)"
                      mat-icon-button
                      class="edit-hidden-button"
                      (click)="editColumnJson(sectionIndex, rowIndex, columnIndex)"
                    >
                      <mat-icon>code</mat-icon>
                    </button>

                    <button
                      matTooltip="Delete tile"
                      mat-icon-button
                      class="edit-hidden-button"
                      (click)="removeColumnFromRow(sectionIndex, rowIndex, columnIndex)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>

                <ng-container *ngIf="column.tileDefinitions">
                  <div [class.suvo-bi-gap-12]="column.tileDefinitions.length > 1">
                    <ng-container *ngFor="let tileDefinition of column.tileDefinitions">
                      <ng-container
                        [ngTemplateOutlet]="tileOutlet"
                        [ngTemplateOutletContext]="{ $implicit: tileDefinition }"
                      ></ng-container>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-template
                  *ngIf="
                    column.tileDefinition &&
                    ((editMode && editingActive) || column.tileDefinition?.tileType !== 'new')
                  "
                  [ngTemplateOutlet]="tileOutlet"
                  [ngTemplateOutletContext]="{ $implicit: column.tileDefinition }"
                >
                  <!-- TILE WRAPPER -->
                  <!-- TILE WRAPPER -->
                  <!-- TILE WRAPPER -->
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- EDIT ADD ROW AT END-->
        <div
          *ngIf="editMode && editingActive"
          style="flex: 0 0 64px"
          class="d-flex fd-col jc-center ai-center"
        >
          <button
            mat-flat-button
            class="new-button row-edit-action"
            (click)="addRow(sectionIndex, null)"
          >
            <mat-icon>add</mat-icon>
            Add Row
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #errorSection>
    <!-- TODO: Fix 'erorr' typo -->
    <suvo-core-error-message
      title="No grid sections"
      message="Provided model not fit for grid intepretation."
    ></suvo-core-error-message>
  </ng-template>
</div>
